import './Piece.css'

function Piece({ piece, onClick }) {

    const kingImageSource = piece.playerType === "white"
        ? "/white-crown.svg"
        : "/black-crown.svg"

    // const pawnImageSource = piece.playerType === "white"
    //     ? "/white-pawn.svg"
    //     : "/black-pawn.svg"

    return (
        <div className={`piece-holder ${piece.captured ? "piece-captured-explode" : ""} ${piece.selected ? "selected" : ""}`}
            style={{
                left: `${piece.x * 12.5}%`,
                top: `${piece.y * 12.5}%`,
            }}
            onClick={onClick}
        >
            <div className={`piece ${piece.playerType === "white" ? "white-piece" : "black-piece"} 
                `}
            >
                {piece.promoted &&
                    <img src={kingImageSource} alt='crown' className='crown-icon' />
                }

                {/* {!piece.promoted &&
                    <img src={pawnImageSource} alt='crown' className='pawn-icon' />
                } */}

            </div>
        </div>
    )
}

export default Piece